'use client';

import { useUnit } from 'effector-react';
import { $customizerPreviewFullscreen } from '@nx-frontend/shared/store/customizer-preview-store';
import { NotificationPanelWrapper } from './notification-panel-wrapper';

export function NotificationPanelCustomizerWrapper() {
  const [customizerPreviewFullscreen] = useUnit([$customizerPreviewFullscreen]);
  return !customizerPreviewFullscreen ? <NotificationPanelWrapper /> : null;
}
